export enum LanguageEnum {
  EN = 'en',
  ES = 'es',
  PT = 'pt',
}
